<template>
  <fieldset>
    <legend>
      <span class="pull-left">{{ headline }}</span>
      <div>
        <a
          v-if="modalText"
          class="fa fa-question-circle"
          @click="displayModal($event, 0)"
        />
        <a
          class="pull-right"
          ref="collapseLink"
          data-toggle="collapse"
          :href="toggleHref"
          role="button"
          aria-expanded="true"
          :aria-controls="id"
        >
          <span class="fa fa-angle-up"></span>
          <span class="fa fa-angle-down"></span>
        </a>
      </div>
    </legend>
    <modal v-show="modals[mIndex]" @close="$set(modals, mIndex, false)" v-for="(m, mIndex) in modalText" :key="mIndex">
      <h2 slot="modal-header">{{ headline }}</h2>
      <div slot="modal-body">
        <div>
          <h5>{{ m.header }}</h5>
          <p>{{ m.text }}</p>
        </div>
      </div>
    </modal>

    <div class="collapse show" :id="id" ref="collapseElement">
      <slot></slot>
    </div>
  </fieldset>
</template>

<script>
export default {
  props: {
    // Text to be show as header for form section
    headline: {
      type: String,
      required: true,
    },
    // Id used through component to do refs for collapse etc.
    id: {
      type: String,
      required: true,
    },
    // Text to be shown in modal (optional)
    // Format: [{header: "Foo", text: "Foo text"},{header: "Bar", text: "Bar text"}]
    modalText: {
      type: Array,
      required: false,
    },
  },
  computed: {
    toggleHref() {
      return `#${this.id}`;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/shared/components/FormSection.vue